import { withTranslation } from "react-i18next";
import ReportSummary from './ReportSummary';

export default withTranslation()(ReportSummary);